<template>
  <div class="keywords-container">
    <h4>Keywords in property description</h4>
    <button class="info-button"  @click="toggleInfoWidget" :class="{showed: showInfo}">
      <svg class="ico">
        <use xlink:href="#info-icon"/>
      </svg>
    </button>
    <ul class="list">
      <li class="tag"
          :key="index"
          @click="toggleTag(getTagName(tag))"
          v-for="(tag, index) in tags"
          :class="{selected: selectedTag === getTagName(tag)}">
        {{tag.name === 'ev charging point' ? 'EV charging point' : tag.name}}
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: {
    tags: Array,
    selectedTag: String,
    showMore: Boolean,
  },
  data: function () {
    return {
      showInfo: false,
    }
  },
  methods: {
    toggleInfoWidget() {
      if (this.showInfo !== true) {
        this.showInfo = true

        setTimeout(() => {
          this.showInfo = false
        }, 2500)
      }
    },
    getTagName(tag) {
      return tag.name === 'ev charging point' ? 'charging' : tag.name;
    },
    toggleTag(tag) {
      this.$emit('toggleTag', tag)
    }
  },
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.keywords-container {
  margin: 0 1.25rem 1.25rem;
  border-bottom: 1px solid #d9d9d9;

  h4 {
    display: inline-block;
  }

  .info-button {
    height: 1.25rem;
    cursor: pointer;
    position: relative;
    align-items: center;
    margin-left: .625rem;
    display: inline-block;
    background: transparent;
    justify-content: center;

    svg {
      fill: #424242;
      width: .75rem;
      height: .75rem;
    }

    &:hover {
      svg {
        fill: $col_primary;
      }
    }

    &.showed {
      svg {
        fill: $col_primary;
      }

      &:before {
        width: 0;
        height: 0;
        top: 1rem;
        right: 1px;
        content: '';
        z-index: 9998;
        position: absolute;
        border-bottom: 0.313rem solid #474747;
        border-left: 0.313rem solid transparent;
        border-right: 0.313rem solid transparent;
      }

      &:after {
        right: -.5rem;
        top: 1.313rem;
        z-index: 9999;
        width: 17.75rem;
        height: 1.875rem;
        font-weight: 100;
        color: $col_white;
        text-align: center;
        position: absolute;
        font-size: 0.625rem;
        line-height: 1.875rem;
        border-radius: 0.188rem;
        background: rgba(0, 0, 0, .72);
        content: 'Clicking on a keyword will highlight it in the property description';
      }
    }
  }
}

.list {
  display: flex;
  flex-wrap: wrap;
  margin: 1.25rem 0;
  grid-row-gap: 0.625rem;
  row-gap: 0.625rem;
  grid-column-gap: 0.625rem;
  -moz-column-gap: .625rem;
  column-gap: 0.625rem;
  padding: 0;
}

.tag {
  color: #424242;
  display: block;
  cursor: pointer;
  transition: .3s;
  min-height: auto;
  list-style: none;
  line-height: 1.2;
  padding: 0.625rem;
  font-size: .875rem;
  text-align: center;
  text-decoration: none;
  border-radius: 0.3125rem;
  background-color: $col_xlgrey;

  &:first-letter {
    text-transform: uppercase;
  }

  &:hover {
    background: $col_medgrey;
  }

  &.selected {
    color: $col_white;
    background: $col_primary;
  }
}

@media #{$l-tablet} {
  .keywords-container {
    .info-button {
      &.showed {
        &:after {
          left: 0;
          right: unset;
          transform: translateX(-50%);
        }
      }
    }
  }
}

@media #{$desktop} {
  .keywords-container {
    margin: 0 0 1.25rem;
  }
}
</style>